/**
 * @param {number} min
 * @param {number} n
 * @param {number} max
 * @returns {number}
 */
export function clamp(min, n, max) {
  return Math.max(Math.min(n, max), min);
}